"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTranslation;

var _isObject = _interopRequireDefault(require("lodash/isObject"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var languagePriorities = ['en', 'ja'];
var alternateLocalesMap = {
  'zh-CN': ['zh-TW'],
  'zh-TW': ['zh-CN']
};
/**
 * Resolves a translation based on a priority list
 * @param translationsObjectOrString
 * @param targetLocale
 * @param defaultTranslation
 * @return {string|*}
 */

function getTranslation(translationsObjectOrString) {
  var targetLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : languagePriorities[0];
  var defaultTranslation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var translationsObject = translationsObjectOrString;
  if (!translationsObject) return defaultTranslation;

  if (!(0, _isObject["default"])(translationsObject)) {
    try {
      translationsObject = JSON.parse(translationsObjectOrString);
    } catch (error) {
      return translationsObjectOrString ? translationsObjectOrString.toString() : defaultTranslation;
    }
  }

  if (translationsObject[targetLocale]) {
    return translationsObject[targetLocale];
  }

  var alternateLocales = alternateLocalesMap[targetLocale];

  if (alternateLocales && alternateLocales.length) {
    for (var i = 0; i < alternateLocales.length; i += 1) {
      var alternateTranslation = translationsObject[alternateLocales[i]];

      if (alternateTranslation) {
        return alternateTranslation;
      }
    }
  }

  var compiledLanguagePriorities = languagePriorities.concat(Object.keys(translationsObject));

  for (var _i = 0; _i < compiledLanguagePriorities.length; _i += 1) {
    if (translationsObject[compiledLanguagePriorities[_i]]) {
      return translationsObject[compiledLanguagePriorities[_i]];
    }
  }

  return defaultTranslation;
}